import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import mutations from './mutations';

// const pad = (num, size) => {
//   const s = '000000000' + num; //eslint-disable-line
//   return s.substr(s.length - size);
// };

Vue.use(Vuex);

const state = {
  title: null,
  printUrl: null,
  pages: [],
  ready: false,
  translations: {
    menuCTA: 'Menu',
    printCTA: 'Printable PDF',
    prev: 'Previous',
    next: 'Next',
    backcoverTitle: 'Committed to sustainable productivity',
    backcoverText: 'We stand by our responsibilities towards our customers, towards the<br>environment and the people around us. We make performance stand<br>the test of time. This is what we call – Sustainable Productivity.',
    productTitle: 'Product',
    threesixtyLabels: 'Labels',
    threesixtyCanopy: 'Canopy',
    threesixtyOn: 'On',
    threesixtyOff: 'Off',
  },
};

const findGetParameter = (parameterName) => { //eslint-disable-line
  let result = null;
  let tmp = [];
  location.search
    .substr(1)
    .split('&')
    .forEach((item) => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

const actions = {
  getProducts: ({ commit }) => {
    const urlParameter = findGetParameter('url');
    const url = urlParameter || 'static/data.json';
    axios.get(url).then((response) => {
    // axios.get(findGetParameter('url')).then((response) => {
    // axios.get('http://local.api.brochure-platform.kubaja.com/sample-page/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/sample-page/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/zs4-zs4vsd/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/zb-5-6-vsd/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/5183-2/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/ga-90-160-vsd/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/mdg-real-content/?json=true').then((response) => {
    // axios.get('http://api.brochure-platform.kubaja.com/jelle/?json=true').then((response) => {
      commit('GET_DATA_SUCCESS', response.data);
    });
  },
};

const getRouterArray = (index, get) => {
  const arr = {};
  if (get.ready) {
    arr.params = {};
    arr.params.id = index;
    arr.name = get.pages[arr.params.id].template;

    if (arr.name === '360') {
      arr.params.tViewIndex = 0;
      arr.params.canopy = 'canopy';
      arr.params.info = 'info';
      arr.params.selectedBullet = -1;
    } else if (arr.name === 'installation-3d') {
      arr.params.info = 'info';
      arr.params.selectedBullet = -1;
    }
  }
  return arr;
};

const getters = {
  translations(st) {
    return st.translations;
  },
  title(st) {
    return st.title;
  },
  printUrl(st) {
    return st.printUrl;
  },
  pageIndex(st) {
    return parseInt(st.route.params.id, 10);
  },
  pageMenuTitle(st) {
    return st.pages[st.route.params.id] ? st.pages[st.route.params.id].menuTitle : '';
  },
  pages(st) {
    return st.pages;
  },
  page(st) {
    return st.pages[st.route.params.id];
  },
  ready(st) {
    return st.ready;
  },
  isFront(st) {
    return st.ready ? st.pages[st.route.params.id].template === 'front' : false;
  },
  nextPageRouterArray(st, get) {
    let arr;
    if ((get.pageIndex + 1) < get.pages.length) {
      arr = getRouterArray(get.pageIndex + 1, get);
    } else {
      arr = false;
    }
    return arr;
  },
  prevPageRouterArray(st, get) {
    let arr;
    if (get.pageIndex > 0) {
      arr = getRouterArray(get.pageIndex - 1, get);
    } else {
      arr = false;
    }
    return arr;
  },
  tViewIndex(st) {
    return st.route.params.tViewIndex;
  },
  canopy(st) {
    return st.route.params.canopy === 'canopy';
  },
  info(st) {
    return st.route.params.info === 'info';
  },
  /* eslint-disable max-len */
  contentBlocks(st, get) {
    const indexedContentBlocks = [];
    if (st.route.name === '360') {
      const contentBlocks = get.canopy ? get.page.threesixtyViews[get.tViewIndex].canopyContentBlocks : get.page.threesixtyViews[get.tViewIndex].nocanopyContentBlocks;
      let index = 0;
      [].forEach.call(contentBlocks, (contentBlock) => {
        const indexedContentBlock = contentBlock;
        if (contentBlock.highlighted) {
          indexedContentBlock.id = index;
          index += 1;
        } else {
          indexedContentBlock.id = -1;
        }
        indexedContentBlocks.push(indexedContentBlock);
      });
    }
    return indexedContentBlocks;
  },
  bulletsJson(st, get) {
    if (st.route.name === '360') {
      return get.canopy ? get.page.threesixtyViews[get.tViewIndex].canopyBulletsJson : get.page.threesixtyViews[get.tViewIndex].nocanopyBulletsJson;
    }
    return {};
  },
  frames(st, get) {
    if (st.route.name === '360') {
      return get.canopy ? get.page.threesixtyViews[get.tViewIndex].canopyFrames : get.page.threesixtyViews[get.tViewIndex].nocanopyFrames;
    }
    return {};
  },
  selectedBullet(st) {
    return parseInt(st.route.params.selectedBullet, 10);
  },
  highlightedFrameIndex(st, get) {
    let index = false;
    if (get.selectedBullet !== -1) {
      [].forEach.call(get.contentBlocks, (contentBlock) => {
        if (contentBlock.id == get.selectedBullet) { //eslint-disable-line
          index = contentBlock.highlightedFrameIndex;
        }
      });
    }
    // if (get.selectedBullet !== false && get.contentBlocks.length > get.selectedBullet && get.contentBlocks[get.selectedBullet].highlighted) {
    //   index = get.contentBlocks[get.selectedBullet].highlightedFrameIndex;
    // }
    return index;
  },
  highlightedFrameUrl(st, get) {
    let url = false;
    if (get.selectedBullet !== -1) {
      [].forEach.call(get.contentBlocks, (contentBlock) => {
        if (contentBlock.id == get.selectedBullet) { //eslint-disable-line
          url = contentBlock.highlightedFrameUrl;
        }
      });
    }
    // if (get.selectedBullet !== false && get.contentBlocks.length > get.selectedBullet && get.contentBlocks[get.selectedBullet].highlighted) {
    //   url = get.contentBlocks[get.selectedBullet].highlightedFrameUrl;
    // }
    return url;
    // return get.selectedBullet !== false && get.contentBlocks.length > get.selectedBullet ? get.contentBlocks[get.selectedBullet].highlightedFrameUrl : false;
  },
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js